module.exports = __webpack_public_path__ + "img/mynewsimg7.7176556b.png";